import { Stack, styled, Theme } from '@mui/material';
import { InputMask } from '@react-input/mask';

import { CustomInputProps } from './types';
import { FieldError } from '../FieldError/FieldError';
import { ChangeEvent } from 'react';

const CustomInputMask = styled(InputMask)(({ theme }) => ({
  background: 'none',
  outline: 0,
  border: 'none',
  fontFamily: 'inherit',
  color: theme.palette.common.white,
  fontSize: '16px',
}));

export const CustomTelInput: React.FC<CustomInputProps> = ({
  error,
  onChange,
  value,
  fieldName,
}) => {
  return (
    <Stack
      alignItems="center"
      sx={(theme: Theme) => ({
        display: 'grid',
        position: 'relative',
        borderBottom: `2px solid ${theme.palette.gray.main}`,
        paddingBottom: '10px',
        marginBottom: { xs: '20px' },
      })}
    >
      <CustomInputMask
        mask="+380 (__) ___-__-__"
        replacement={{ _: /\d/ }}
        value={value}
        name={fieldName}
        placeholder="+380 (__) ___-__-__"
        // The mask only ever accepts digits, but without these the phone field
        // opened a full qwerty keyboard on iOS and the driver had to find the
        // 123 key before they could type a single character of their number.
        // `tel` also lets the browser offer the number it already knows.
        type="tel"
        inputMode="tel"
        autoComplete="tel"
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value)
        }
      />
      <FieldError error={error} />
    </Stack>
  );
};
